"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
const svgs = {};
// Import and re-export all svg files in this folder as react components
if (process.env.NODE_ENV === 'test') {
    // When testing, we don't have require.context. In that case, we are running in node,
    // and we can directly read the file system.
    const fs = require('fs');
    fs.readdirSync('.').forEach(relativeFilePath => {
        const parts = relativeFilePath.split('.');
        const ext = parts.slice(-1);
        if (ext !== 'svg')
            return;
        const name = parts.slice(0, -1).join('.');
        svgs[name] = require(`./${relativeFilePath}`);
    });
}
else {
    const svgModules = require.context('.', false, /\.svg$/);
    svgModules.keys().forEach(key => {
        const name = key.match(/^.*\/(.*)\.svg$/)[1];
        svgs[name] = svgModules(key).default || svgModules(key);
    });
}
exports.default = svgs;
//# sourceMappingURL=index.js.map